module.exports = __webpack_public_path__ + "assets/img/87@3x.221395f4.png";